import MarkerProps from "./markerProps"
import { markerSizes } from "./markerSizes"

const CrcMarker = ({
  size = 'medium',
}:MarkerProps) => {

  return (
    <svg width={markerSizes[size].width} height={markerSizes[size].height} viewBox="0 0 31 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 15.4C0 6.886 6.886 0 15.4 0C23.914 0 30.8 6.886 30.8 15.4C30.8 24.7662 20.673 37.7492 16.8434 42.3238C16.0829 43.2323 14.7171 43.2323 13.9566 42.3238C10.127 37.7492 0 24.7662 0 15.4Z" fill="#4AA181"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.8999 15.4C9.8999 18.436 12.3639 20.9 15.3999 20.9C18.4359 20.9 20.8999 18.436 20.8999 15.4C20.8999 12.364 18.4359 9.90002 15.3999 9.90002C12.3639 9.90002 9.8999 12.364 9.8999 15.4Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4079 42.8588C14.9321 43.4752 15.8679 43.4752 16.3921 42.8588C19.7972 38.8551 30.8 25.1628 30.8 15.4C30.8 6.886 23.914 0 15.4 0C6.886 0 0 6.886 0 15.4C0 25.1628 11.0028 38.8551 14.4079 42.8588ZM14.1584 40.2102C15.0813 41.3473 15.7187 41.3473 16.6416 40.2102C18.066 38.4551 19.9628 35.9992 21.8566 33.1923C23.7532 30.3812 25.6284 27.2452 27.0248 24.1281C28.4301 20.9914 29.3 17.984 29.3 15.4C29.3 7.71443 23.0856 1.5 15.4 1.5C7.71443 1.5 1.5 7.71443 1.5 15.4C1.5 17.984 2.36991 20.9914 3.77516 24.1281C5.1716 27.2452 7.04677 30.3812 8.94345 33.1923C10.8372 35.9992 12.734 38.4551 14.1584 40.2102Z" fill="black" fill-opacity="0.2"/>
    </svg>
  )
}

export default CrcMarker
